import * as React from 'react';
import * as classNames from 'classnames';
import {GutterSize} from '../../common/enums';

// interface declaration
interface IInputProps {
  className?: string;
  placeholder?: string;
  type?: 'text' | 'password' | 'email' | 'checkbox' | 'radio';
  value?: string;
  onChange?: (value: string) => any;
  onBlur?: (e: React.KeyboardEvent<any>) => void;
  onKeyDown?: (e: React.KeyboardEvent<any>) => void;
  onKeyPress?: (e: React.KeyboardEvent<any>) => void;
  onFocus?: (e: React.KeyboardEvent<any>) => void;
  checked?: boolean;
  error?: string;
  name?: string;
  reference?: (node: HTMLElement) => any;
  autocomplete?: boolean | string;
  highlightError?: boolean;
  bottomSpacing?: GutterSize;
  focused?: boolean;
  disabled?: boolean;
  fontWeightNormal?: boolean;
}

// components declaration
import {BubbleError} from '../bubble-error/bubble-error';

// style declaration
import './style.sass';

export class Input extends React.Component<IInputProps, any> {
  private currentElement: HTMLElement;

  public componentDidMount(): void {
    if (this.props.focused) {
      this.currentElement.focus();
    }
  }

  public componentDidUpdate(): void {
    if (this.props.focused) {
      this.currentElement.focus();
    }
  }

  public render(): React.ReactElement<any> {
    const {
      placeholder, type, value, onChange, onBlur, onFocus,
      onKeyDown, onKeyPress, checked, error, name, autocomplete,
      highlightError, bottomSpacing, className, disabled,
      fontWeightNormal,
    } = this.props;

    const inputProps: any = {
      type: type ? type : 'text',
    };

    if (type !== 'checkbox' && type !== 'radio') {
      inputProps.value = value;
    } else {
      inputProps.checked = Boolean(checked);
    }

    if (onChange) {
      inputProps.onChange = (e: any) => {
        if (type !== 'checkbox' && type !== 'radio') {
          onChange(e.target.value);
        } else {
          onChange(e);
        }
      };
    }

    if (autocomplete === true) {
      inputProps.autoComplete = 'on';
    } else if (autocomplete === false) {
      inputProps.autoComplete = 'off';
    } else {
      inputProps.autoComplete = autocomplete;
    }

    // this is from http://stackoverflow.com/questions/15738259/disabling-chrome-autofill
    // http://benjaminjshore.info/2014/05/chrome-auto-fill-honey-pot-hack.html
    const autocompletePreventingMarkup = autocomplete === false
      ? (
      <input type={'text'} style={{display: 'none'}}/>
    ) : null;

    return (
      <div className={classNames(
        'input-component--container', /* @TODO element can not wrap block  */
        {[`input-component_bottom-spacing_${bottomSpacing}`]: bottomSpacing},
        {'input-component--container__radio': type === 'radio'},
        className,
      )}>
        {autocompletePreventingMarkup}
        <input
          className={classNames(
            'input-component',
            {'input-component_disabled': disabled},
            {'input-component_font-weight-normal': fontWeightNormal},
            {'input-component_error': !!error || highlightError},
          )}
          placeholder={placeholder}
          name={name}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          onKeyPress={onKeyPress}
          onFocus={onFocus}
          disabled={disabled}
          ref={this.addReference}
          {...inputProps}
        />

        <BubbleError error={error} />
      </div>
    );
  }

  private addReference = (node: HTMLElement): void => {
    this.currentElement = node;

    if (this.props.reference) {
      this.props.reference(node);
    }
  };
}
